/** #@condition: builtInAuthorizationUI **/
/** Only if we need built in authorization **/
import {AbstractVisualFeature} from '../../visual-feature.js';
import {Dialogs} from '../dialogs.js';

import {loginDialogConfig} from './login-dialog.factory';

import PALETTE_SCHEMA from './login-dialog.palette-schema.yaml';

class LoginDialogFeature extends AbstractVisualFeature {
    get name() {
        return 'LoginDialog';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return loginDialogConfig(PALETTE);
    }
}

new LoginDialogFeature(Dialogs);
